import { observer } from 'mobx-react';
import Buttons from './Buttons';
import Description from './Description';
import DisplayButtonLabel from './DisplayButtonLabel';
import DisplayType from './DisplayType';
import Name from './Name';
import { LearningDesignSection } from '../../../../../Types';
import { CloseAction } from '../../../../../../../Modal/UseOpenable';
import useLearningDesignDetailsForm from './useLearningDesignDetailsForm';
import LearningCollectionEditStore from '../../../../../Edit/Store';

interface Props {
  close: CloseAction;
  section: LearningDesignSection;
  store: LearningCollectionEditStore;
}

function LearningDesignDetailsForm({ close, section, store }: Props) {
  const {
    formName,
    setFormName,
    formDescription,
    setFormDescription,
    formDisplayType,
    setFormDisplayType,
    formDisplayButtonLabel,
    setFormDisplayButtonLabel,
    save,
    isSaveDisabled,
  } = useLearningDesignDetailsForm(section, close, store);

  return (
    <>
      <Name name={formName} onChange={setFormName} />
      <Description description={formDescription} onChange={setFormDescription} />
      <DisplayType section={section} displayType={formDisplayType} onChange={setFormDisplayType} />
      <DisplayButtonLabel
        displayButtonLabel={formDisplayButtonLabel}
        onChange={setFormDisplayButtonLabel}
      />
      <Buttons save={save} close={close} disabled={isSaveDisabled} />
    </>
  );
}

export default observer(LearningDesignDetailsForm);
